import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const userFriendlyDateFormat = "Y-m-d H:i";

export const DateTimePicker = ({
  name,
  currentDate,
  maxDate,
  onChange,
}: {
  name: string;
  currentDate: number;
  maxDate: number;
  onChange: (currentDate: number) => void;
}) => (
  <Flatpickr
    value={currentDate}
    onChange={(date: Date[]) => onChange(date[0]?.valueOf())}
    options={{
      maxDate: maxDate,
      allowInput: false,
      dateFormat: userFriendlyDateFormat,
      time_24hr: true,
      enableTime: true,
    }}
    render={({ defaultValue }, ref) => (
      <input
        autoComplete="off"
        data-input
        ref={ref}
        defaultValue={defaultValue}
        name={name}
        id={name}
        type="text"
        className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
      />
    )}
  />
);
